/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_BlockedInputs */



/**
* | output |
* | --- |
* | "Your browser is blocking the microphone for Wundo. Allow it in your browser, then try again." |
*
* @param {Practice_Session_Mic_BlockedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked = /** @type {((inputs?: Practice_Session_Mic_BlockedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_BlockedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je browser blokkeert de microfoon voor Wundo. Geef toegang in je browser en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre navigateur bloque le micro pour Wundo. Autorisez-le dans votre navigateur, puis réessayez.")
	return /** @type {LocalizedString} */ ("Your browser is blocking the microphone for Wundo. Allow it in your browser, then try again.")
});